// @flow
//eslint-disable-next-line

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Sidebar from 'react-sidebar'

import {
	ANALYTICS_HELPER,
	CONSTANTS,
	PRODUCT_HELPER,
	HELPER,
	MANAGE_CART_HELPER,
} from '../../../../utils'
import { metaAction } from '../../../../store/actions'
import { useTranslation } from '../../../../hooks'
import { CartActions } from '../../../../containers'
import ProductAtrributes from './ProductAtrributes'

const SideBarComponent = () => {
	let translate = useTranslation()
	const { items } = useSelector((state) => state.cart.cart_items)
	const { showProductDetail } = useSelector((state) => state.action)
	const { selected_product } = useSelector((state) => state.inventory)
	const { maximum_purchase_limit } = useSelector((state) => state.inventory.inventory_settings)
	const { selected_variant } = selected_product

	const ADD_TO_CART = () => {
		let itemAdded = true
		let itemFound = { qty: 1 }
		let res = items.find((item) => {
			return (
				item.product.id === selected_product.id &&
				item.product.selected_variant.variant_id === selected_product.selected_variant.variant_id
			)
		})
		if (HELPER.isNotEmpty(res)) {
			const total_amount = selected_variant.price * (res.qty + 1)
			itemAdded = MANAGE_CART_HELPER.AddCartRule(
				maximum_purchase_limit,
				selected_product.product_delivery_type,
				total_amount
			)
			if (itemAdded) {
				res.qty = res.qty + 1
				itemFound = res
			}
		}
		const max_quantity = PRODUCT_HELPER.PRODUCT_MAX_QUANTITY(selected_product)
		if (itemFound?.qty <= max_quantity && itemAdded && max_quantity > 0) {
			PRODUCT_HELPER.ADD_PRODUCT_TO_CART(selected_product, CONSTANTS.ADD_QTY, itemFound?.qty)
		} else if (itemFound?.qty > max_quantity && !HELPER.isEmpty(res) && max_quantity > 0) {
			res.qty = res.qty - 1
			itemFound = res
			MANAGE_CART_HELPER.MaxQuantityReached(selected_product)
		} else if (max_quantity <= 0) {
			MANAGE_CART_HELPER.outOfStock()
		}
		return true
	}

	return !showProductDetail ? (
		<>
			<span> </span>
		</>
	) : HELPER.isNotEmpty(selected_variant?.variant_id) ? (
		<>
			{/* <Slide right key={`productSlide-${selected_variant?.variant_id}`} collapse duration={1000} when={showProductDetail ? true : false}> */}
			{/* key={`productMenu-${selected_variant?.variant_id}`} */}
			<div className="productMenu">
				<div className="insidePrdMenuBox sidebarPrdMenuBox">
					<div
						className="prdMenuImgBox"
						onClick={() => PRODUCT_HELPER.PRODUCT_SELECTION(selected_product)}
					>
						<div>
							<div className="prdMenuImg">
								<img
									src={PRODUCT_HELPER.PRODUCT_IMAGE(selected_product).src}
									alt={PRODUCT_HELPER.PRODUCT_IMAGE(selected_product).alt}
								/>
							</div>
						</div>
					</div>
					<div className="prodMenuDetailsWrap">
						<div className="prodName">
							<span>{PRODUCT_HELPER.FORMAT_PRODUCT_NAME(selected_product)}</span>
						</div>
						<div className="prodDescription">
							{PRODUCT_HELPER.DISPLAY_SHORT_DESCRIPTION(selected_product)}
						</div>
						<div className="prodAddNotes">
							{PRODUCT_HELPER.DISPLAY_ADDITIONAL_NOTES(selected_product)}
						</div>
					</div>

					<ProductAtrributes selected_product={selected_product} />
				</div>
			</div>
			{/* </Slide> */}
			<div className="productFooter" key={`productFooter-${selected_variant?.variant_id}`}>
				<div className="insideProductFooter">
					<div className="insideProductFooterContainer">
						<div className="cartPrdRight">
							<CartActions
								product={selected_product}
								key={`CartActions-${selected_variant?.variant_id}`}
							/>
						</div>
						<div className="cartPrdLeft">
							<div className="prodPrice suggestPrice strikeText">
								{PRODUCT_HELPER.FORMAT_PRICE(selected_product)}
							</div>
							<div className="prodPrice newPrice">
								{PRODUCT_HELPER.FORMAT_DISCOUNTED_PRICE(selected_product)}
							</div>
						</div>
					</div>
					<div className="insideProductFooterContainer">
						<button className="addedinCartBtn blueSubmitBtn" onClick={ADD_TO_CART}>
							{translate('CART.ADD_TO_CART')}
						</button>
						<button
							className="blueSubmitBtn"
							onClick={() => PRODUCT_HELPER.BUY_NOW(selected_product)}
						>
							{translate('CART.BUY_NOW')}
						</button>
					</div>
				</div>
			</div>
		</>
	) : (
		''
	)
}

const WebProductDetail = () => {
	let dispatch = useDispatch()
	const { showProductDetail } = useSelector((state) => state.action)
	const { selected_product } = useSelector((state) => state.inventory)

	const accordianToggle = () => {
		ANALYTICS_HELPER._productDetail(selected_product)
		dispatch(metaAction.PRODUCT_DETAIL_SIDEBAR_OPEN())
	}

	return showProductDetail && HELPER.isNotEmpty(selected_product) ? (
		<div onClick={() => accordianToggle()}>
			{/* <Slide key={`slide-sidebar-${selected_product?.id}`} collapse right when={showProductDetail ? true : false} in={showProductDetail ? true : false}> */}
			<Sidebar
				sidebar={<div onClick={(e) => e.stopPropagation()}>{<SideBarComponent />}</div>}
				open={showProductDetail}
				docked={true}
				transitions={false}
				touch={true}
				pullRight={true}
				shadow={true}
				contentClassName="product-detail-content"
				sidebarClassName="product-detail-sidebar"
				overlayClassName={'product-detail-overlay'}
				dragToggleDistance={20}
			>
				<div className={`closeProductMenu ${showProductDetail ? '' : 'd-none'}`}>
					<button>
						<i className="icon-icon-caret-down"></i>
					</button>
				</div>
			</Sidebar>
			{/* </Slide >  */}
		</div>
	) : (
		''
	)
}

export default WebProductDetail
